export default "/build/images/termometre_mask.7b0c0f1a.png";